export default __webpack_public_path__ + "static/media/DojimaNetwork_logo.bf406534.jpeg";